<template>
<app-modal v-model="isDialogOpened"
           size="md"
           :ok-text="$t('common.confirm')"
           @ok="confirm"
           @cancel="closeDialog"
>
  <template #title>{{ $t('project.checklist.dialogs.ChecklistStatusDialogCloseConfirmation.dialogTitle') }}</template>
  <template #body>
    <v-row>
      <v-col class="text--primary">
        {{ $t('project.checklist.dialogs.ChecklistStatusDialogCloseConfirmation.dialogText') }}
      </v-col>
    </v-row>
  </template>
</app-modal>
</template>

<script>
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'ChecklistStatusDialogCloseConfirmation',
  emits: ['confirm'],
  mixins: [dialogMixin],
  methods: {
    confirm () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
